import React, { useState } from 'react';
import FilesList from './FilesList';
import FilesAddForm from './FilesAddForm';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import { Icon } from '../../components/Icon/Icon';

const FilesPage = ({ files, parent }) => {
  const [openUploadFile, setOpenUploadFile] = useState(null);
  return (
    <div>
      <div style={{ textAlign: 'left' }}>
        <Button circle title={'Upload file'} onClick={() => setOpenUploadFile(true)}>
          <Icon>add</Icon>
        </Button>
      </div>
      <FilesList files={files} />
      <Modal open={openUploadFile} onClose={() => setOpenUploadFile(false)}>
        <FilesAddForm parent={parent} onSubmit={() => setOpenUploadFile(false)} />
      </Modal>
    </div>
  );
};

export default FilesPage;
